function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(79.215686%,78.823529%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 24.003906 24.207031 L 24 24.207031 C 21.300781 24.207031 19.101562 26.402344 19.101562 29.097656 C 19.097656 30.347656 19.574219 31.539062 20.414062 32.4375 L 19.964844 36.46875 L 19.949219 36.738281 C 19.949219 37.367188 20.191406 37.960938 20.636719 38.402344 C 21.082031 38.847656 21.671875 39.09375 22.300781 39.09375 L 25.699219 39.09375 L 25.957031 39.078125 C 27.246094 38.9375 28.179688 37.769531 28.039062 36.480469 L 27.589844 32.4375 C 28.425781 31.539062 28.90625 30.347656 28.902344 29.101562 C 28.898438 26.40625 26.699219 24.207031 24.003906 24.207031 Z M 25.125 30.621094 L 24.417969 31.132812 L 24.964844 36.085938 L 23.03125 36.085938 L 23.585938 31.132812 L 22.875 30.621094 C 22.394531 30.269531 22.105469 29.703125 22.109375 29.105469 C 22.109375 28.0625 22.957031 27.214844 24.003906 27.214844 L 24.003906 25.710938 L 24.003906 27.214844 C 25.046875 27.214844 25.894531 28.0625 25.894531 29.109375 C 25.894531 29.703125 25.609375 30.269531 25.125 30.621094 Z M 25.125 30.621094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(79.215686%,78.823529%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 24 7.207031 C 19.425781 7.207031 15.703125 10.929688 15.703125 15.507812 L 15.703125 20.40625 L 32.296875 20.40625 L 32.300781 15.507812 C 32.296875 10.929688 28.574219 7.207031 24 7.207031 Z M 29.289062 17.398438 L 18.707031 17.398438 L 18.707031 15.507812 C 18.707031 12.589844 21.082031 10.214844 24 10.214844 C 26.917969 10.214844 29.289062 12.589844 29.289062 15.507812 Z M 29.289062 17.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(79.215686%,78.823529%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 38.4375 17.398438 L 37.394531 17.398438 L 37.394531 15.507812 C 37.394531 8.121094 31.386719 2.113281 24 2.113281 C 16.613281 2.113281 10.605469 8.121094 10.605469 15.507812 L 10.605469 17.398438 L 9.5625 17.398438 C 8.265625 17.398438 7.210938 18.453125 7.207031 19.753906 L 7.207031 40.988281 C 7.210938 43.6875 9.40625 45.886719 12.109375 45.886719 L 35.894531 45.886719 C 38.59375 45.886719 40.789062 43.6875 40.789062 40.988281 L 40.789062 19.753906 C 40.789062 18.453125 39.734375 17.398438 38.4375 17.398438 Z M 37.78125 40.988281 C 37.78125 42.03125 36.933594 42.878906 35.890625 42.878906 L 12.109375 42.878906 C 11.066406 42.878906 10.214844 42.03125 10.214844 40.988281 L 10.214844 20.40625 L 13.613281 20.40625 L 13.613281 15.507812 C 13.613281 9.78125 18.273438 5.121094 24 5.121094 C 29.726562 5.121094 34.386719 9.78125 34.386719 15.507812 L 34.386719 20.40625 L 37.78125 20.40625 Z M 37.78125 40.988281 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c06826b07583bea3a2e7d4d341279d09.svg";
export { ForwardRef as ReactComponent };